<template>
  <div class="criterion-comparative-table">
    <label class="w-100 text-center m-0">
      {{ $t('engineering.isolation-aging.criterion-comparative-table') }}
    </label>
    <s-table
      small
      :fields="fields"
      :items="items"
      :busy="loadingTable"
    >
      <template #thead-top>
        <b-tr>
          <b-th>
            <span class="sr-only">Criterion</span>
          </b-th>
          <b-th
            class="criterion-comparative-table__t-head-top"
            :colspan="windingNumber"
          >
            {{ $t('general.windings') }}
          </b-th>
        </b-tr>
      </template>
      <template #head(criterionName)="data">
        {{ $t(data.label) }}
      </template>
      <template #cell(winding1)="data">
        <s-number
          v-if="showNumber(data.value.value)"
          :fallback-value="numberFallback"
          :value="data.value.value"
          :number-format-options="getFormatOptions(data.value.precision)"
        />
        <span v-else>-</span>
      </template>
      <template #cell(winding2)="data">
        <s-number
          v-if="showNumber(data.value.value)"
          :fallback-value="numberFallback"
          :value="data.value.value"
          :number-format-options="getFormatOptions(data.value.precision)"
        />
        <span v-else>-</span>
      </template>
      <template #cell(winding3)="data">
        <s-number
          v-if="showNumber(data.value.value)"
          :fallback-value="numberFallback"
          :value="data.value.value"
          :number-format-options="getFormatOptions(data.value.precision)"
        />
        <span v-else>-</span>
      </template>
    </s-table>
  </div>
</template>

<script>
import comparativeTableFields
  from '@/domain/data/installation/engineering/isolationAging/comparative-table-fields.json';

export default {
  name: 'CriterionComparativeTable',
  props: {
    tableItems: {
      type: Array,
      default: () => ([]),
    },
    loadingTable: {
      type: Boolean,
      default: false,
    },
    windingNumber: {
      type: Number,
      default: 3,
    },
  },
  data: () => ({
    numberFallback: '-',
  }),
  computed: {
    fields() {
      const FIXED_COL_NUMBER = 1;
      return comparativeTableFields.slice(0, this.windingNumber + FIXED_COL_NUMBER);
    },
    items() {
      return this.tableItems.map((tableItem) => {
        const winding1 = tableItem.windings.find(winding => winding.windingId === 1) || {};
        const winding2 = tableItem.windings.find(winding => winding.windingId === 2) || {};
        const winding3 = tableItem.windings.find(winding => winding.windingId === 3) || {};
        return {
          criterionName: tableItem.criterionName,
          winding1: { value: winding1.value, precision: tableItem.decimalNumbers },
          winding2: { value: winding2.value, precision: tableItem.decimalNumbers },
          winding3: { value: winding3.value, precision: tableItem.decimalNumbers },
        };
      });
    },
  },
  methods: {
    showNumber(value) {
      return typeof value === 'number';
    },
    getFormatOptions(precision) {
      if (typeof precision !== 'number') {
        return null;
      }
      return {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
      };
    },
  },
};
</script>

<style lang="sass"
  scoped>
$winding-value-cell-min-width: 90px

.criterion-comparative-table
  &__t-head-top
    width: $winding-value-cell-min-width * 3

  ::v-deep table
    thead tr:first-child
      border: 3px solid var(--color-background-light)
      border-right: 0

      th:first-child
        background-color: var(--color-background-light)

      th:last-child
        text-align: center !important
        border-radius: 12px 12px 0 0

    tr th, tr td
      border: 3px solid var(--color-background-light)

    tr th:last-child, tr td:last-child
      text-align: center !important

    tr th:last-child
      border-radius: 0 0 10px

    tr td:not(tr td:first-child)
      min-width: $winding-value-cell-min-width
      padding: 2px

    tr:last-child th:first-child
      border-radius: 10px 0 0 10px

    tr.b-table-busy-slot
      .empty-list
        opacity: 1
</style>
